import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {
	MAT_DIALOG_DATA,
	MatDialogRef,
	MatDialogTitle,
	MatDialogContent,
	MatDialogActions,
} from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';

@Component({
	selector: 'delete-document-dialog',
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: 'delete-document-dialog.html',
	imports: [
		MatDialogTitle,
		CdkScrollable,
		MatDialogContent,
		MatDialogActions,
		MatButton,
	],
})
export class DeleteDocumentDialog {
	readonly dialogRef = inject(MatDialogRef<DeleteDocumentDialog>);
	readonly data = inject<DialogData>(MAT_DIALOG_DATA);

	deleteFile(confirmDelete: boolean): void {
		this.dialogRef.close(confirmDelete);
	}
}

export interface DialogData {
	type: string;
	fileName: string;
}
